import React from "react";
import { Outlet } from "react-router-dom";

const Instellingen = () => {
    return (
        <Outlet />
    )
};

export default Instellingen;